import styled from 'styled-components';

const itemSizes = {
    small: {
        maxWidth: '600px',
        backgroundColor: '#1F1F1F',
        marginBottom: '15px',
        cursor: 'auto'
    },
    normal: {
        maxWidth: '800px',
        backgroundColor: '#1F1F1F',
        marginBottom: '0px',
        cursor: 'pointer'
    }
}

const results = {
    w: {
        text: 'Wygrana',
        color: '#00FF00'
    },
    l: {
        text: 'Przegrana',
        color: '#DC143C'
    },
    d: {
        text: 'Remis',
        color: '#DCDCDC'
    }
}

const stageList = ['Faza grupowa', 'Ćwierćfinał', 'Półfinał', 'Mecz o 3. miejsce', 'Finał']

export const MatchContainer = styled.div`
    width: 100%;
    max-width: ${itemSizes.normal.maxWidth};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 15px;
`;

export const MatchDetails = styled.div`
    height: ${({showItem}) => showItem ? '100%' : 0};
    opacity: ${({showItem}) => showItem ? 1 : 0};
    background-color: #3d3d3d;
    width: 90%;
    color: white;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
`;

export const TeamInfo = styled.p`
    font-family: Roboto Condensed, serif;
    color: white;
    font-weight: bold;
    font-size: 11px;
    margin: 0;
    margin-bottom: 5px;
`;

export const TeamInfoText = styled.span`
    font-weight: 300;
    color: #dbdbdb;
`;

export const PlayerTitleDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;

export const PlayerTitle = styled.p`
    flex: 2;
    font-size: 10px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

export const PlayerGoals = styled.p`
    font-size: 11px;
    color: #c2c2c2;
    opacity: ${({goals}) => goals ? 1 : 0};
`;

export const PlayerInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 140px;
    background-color: #00000090;
    border-radius: 5px;
    margin: 5px;
`;

export const TeamDiv = styled.div`
    margin: 5px;
`;

export const IconWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const MatchItem = styled.div`
    width: 98%;
    max-height: 68px;
    max-width: ${({size}) => itemSizes[size].maxWidth};
    background-image: linear-gradient(to right, #333333, #1F1F1F);
    border-radius: 15px;
    border: 1px solid black;
    text-align: center;
    line-height: 34px;
    font-size: 11px;
    font-family: Roboto Condensed, serif;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-bottom: ${({size}) => itemSizes[size].marginBottom};
    position: relative;
    z-index: 1;
    cursor: ${({size}) => itemSizes[size].cursor};
           
    @media (max-width: 450px) {
        font-size: 10px;
    }
    
    @media (max-width: 400px) {
        justify-content: flex-end;
    }
    
    @media (max-width: 330px) {
        justify-content: center;
    }
    
`;

export const TeamTitle = styled.p`
    display: flex;
    color: white;
    margin-top: 0;
    margin-bottom: 0;
    align-items: center;
    justify-content: center;
    white-space: pre;
    width: 175px;
    
    @media (max-width: 630px) {
        width: 150px;
    }
    
    @media (max-width: 550px) {
        width: 100px;
    }
`;

export const Score = styled.span`
    color: ${({result}) => result ? results[result].color : 'white'};
    margin-top: 0;
    margin-bottom: 0;
    font-weight: bold;
    white-space: pre;
`;

export const ScoreContainer = styled.div`
    width: 35px;
`;

export const MatchInfo = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
`;

export const DateInfo = styled.span`
    flex: 1;
    font-weight: 300;
    color: #FFFFFF90;
    line-height: 1;
    
    @media (max-width: 330px) {
        display: none;
    }
`;

export const ResultInfo = styled.span`
    flex: 1;
    font-weight: 300;
    color: ${({result}) => results[result].color};
    
    &:after {
        content: "${({result}) => results[result].text}";
    }
    
    @media (max-width: 400px) {
        display: none;
    }
`;

export const StageInfo = styled.span`
    flex: 1;
    font-weight: 300;
    color: grey;
    line-height: 1;
    
    &:after {
        content: "${({round}) => stageList[round]}";
    }
    
    @media (max-width: 300px) {
        display: none;
    }
`;

export const MiscInfo = styled.div`
    flex: 1;    
    display: flex;
    align-items: center;
    justify-content: center;
        
    @media (max-width: 300px) {
        display: none;
    }
`;
